export const VALIDATION_MESSAGES = {
  REQUIRED_FIRST_NAME: 'First name is required',
  REQUIRED_LAST_NAME: 'Last name is required',
  REQUIRED_TECH_STACK: 'Tech stack is required',
  REQUIRED_TOOLS: 'Tools are required',
};